import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { emailConfig } from '../config/emailConfig';
import './Contacto.css';

const Contacto = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    nombre: '',
    empresa: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', null

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Función para sanitizar datos
  const sanitizeInput = (input) => {
    return input.replace(/[<>]/g, '').trim();
  };

  // Función para validar email
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validaciones de seguridad
    if (!formData.nombre || !formData.email || !formData.mensaje) {
      setSubmitStatus('error');
      return;
    }

    if (!validateEmail(formData.email)) {
      setSubmitStatus('error');
      return;
    }

    // Sanitizar datos antes de enviar
    const sanitizedData = {
      nombre: sanitizeInput(formData.nombre),
      empresa: sanitizeInput(formData.empresa),
      email: sanitizeInput(formData.email),
      telefono: sanitizeInput(formData.telefono),
      mensaje: sanitizeInput(formData.mensaje)
    };

    setIsSubmitting(true);
    setSubmitStatus(null);

    // Preparar los datos para EmailJS
    const templateParams = {
      user_name: sanitizedData.nombre,
      user_company: sanitizedData.empresa,
      user_email: sanitizedData.email,
      user_phone: sanitizedData.telefono,
      user_message: sanitizedData.mensaje,
      to_email: emailConfig.toEmail,
      date: new Date().toLocaleString('es-CL')
    };

    emailjs.send(emailConfig.serviceId, emailConfig.templateId, templateParams, emailConfig.publicKey)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          empresa: '',
          email: '',
          telefono: '',
          mensaje: ''
        });
      })
      .catch((err) => {
        console.log('FAILED...', err);
        setSubmitStatus('error');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <div className="contacto">
      {/* Hero Section */}
      <section className="contacto-hero">
        <div className="container">
          <h1 className="contacto-title">Contáctenos</h1>
          <p className="contacto-subtitle">
            Estamos aquí para ayudarle. Contáctenos para recibir asesoría personalizada 
            y encontrar la solución perfecta para sus necesidades de pesaje industrial.
          </p>
        </div>
      </section>

      {/* Información de Contacto y Formulario */}
      <section className="section contacto-content">
        <div className="container">
          <div className="contacto-grid">
            {/* Información de Contacto */}
            <div className="contacto-info">
              <h2>Información de Contacto</h2>
              <p>
                Nuestro equipo de expertos está listo para atenderle y proporcionarle 
                la mejor solución para sus necesidades de pesaje industrial.
              </p>

              <div className="contacto-details">
                <div className="contacto-item">
                  <div className="contacto-icon">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.96.3 1.9.6 2.8a2 2 0 0 1-.4 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.5 2.8.6a2 2 0 0 1 1.8 2.1Z" />
                    </svg>
                  </div>
                  <div className="contacto-text">
                    <h3>Teléfono</h3>
                    <p>+56 9 7623 4326</p>
                  </div>
                </div>

                <div className="contacto-item">
                  <div className="contacto-icon">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <rect x="3" y="5" width="18" height="14" rx="2" />
                      <path d="m3 7 9 6 9-6" />
                    </svg>
                  </div>
                  <div className="contacto-text">
                    <h3>Email</h3>
                    <p>contacto@servibalanzas.cl</p>
                  </div>
                </div>

                <div className="contacto-item">
                  <div className="contacto-icon">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M20 10c0 5.5-8 12-8 12s-8-6.5-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx="12" cy="10" r="2.8" />
                    </svg>
                  </div>
                  <div className="contacto-text">
                    <h3>Ubicación</h3>
                    <p>Santiago, Chile</p>
                  </div>
                </div>

                <div className="contacto-item">
                  <div className="contacto-icon">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" />
                      <path d="M12 7v5l3.5 2" />
                    </svg>
                  </div>
                  <div className="contacto-text">
                    <h3>Horarios de Atención</h3>
                    <p>Lunes - Viernes: 8:30 AM - 17:15 PM</p>
                    <p>Emergencias: 24/7</p>
                  </div>
                </div>
              </div>


            </div>

            {/* Formulario de Contacto */}
            <div className="contacto-form">
                             <h2>Solicitar Información</h2>
               <p>Complete el formulario y nos pondremos en contacto con usted en menos de 24 horas.</p>

               {submitStatus === 'success' && (
                 <div className="success-message">
                   ✅ ¡Gracias por contactarnos! Nos pondremos en contacto con usted pronto.
                 </div>
               )}

               {submitStatus === 'error' && (
                 <div className="error-message">
                   ❌ Hubo un error al enviar el mensaje. Por favor, inténtelo nuevamente o contáctenos directamente.
                 </div>
               )}

               <form ref={form} onSubmit={handleSubmit} className="form">
                <div className="form-group">
                  <label htmlFor="nombre">Nombre Completo *</label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    placeholder="Su nombre completo"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="empresa">Empresa</label>
                  <input
                    type="text"
                    id="empresa"
                    name="empresa"
                    value={formData.empresa}
                    onChange={handleChange}
                    placeholder="Nombre de su empresa"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="su@email.com"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="telefono">Teléfono</label>
                    <input
                      type="tel"
                      id="telefono"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleChange}
                      placeholder="+56 9 1234 5678"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="mensaje">Mensaje *</label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Describa sus necesidades o consulta..."
                  ></textarea>
                </div>

                                 <button 
                   type="submit" 
                   className="btn btn-primary submit-btn"
                   disabled={isSubmitting}
                 >
                   {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                 </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-contacto">
        <div className="container">
          <div className="cta-content">
            <h2>¿Necesita una respuesta inmediata?</h2>
            <p>
              Para consultas urgentes o emergencias, contáctenos directamente por teléfono o WhatsApp.
            </p>
            <div className="cta-buttons">
              <a 
                                  href="https://wa.me/+56976234326?text=Hola,%20necesito%20ayuda%20urgente%20con%20mi%20equipo%20de%20pesaje" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-secondary"
              >
                📱 WhatsApp Urgente
              </a>
              <a 
                href="tel:+56976234326"
                className="btn btn-primary"
              >
                📞 Llamar Ahora
              </a>
            </div>
          </div>
                 </div>
       </section>
     </div>
     </>
   );
 };

export default Contacto; 
